<div class="app-shell">

  <app-manga-navbar
    [activeManga]="selectedMangaId"
    (mangaSelected)="onMangaSelected($event)"
    (openUploadWindowClicked)="onOpenUploadWindowClicked()"
    (openSettingsWindowClicked)="onOpenSettingsWindowClicked()">
  </app-manga-navbar>

  <div class="body">

    <div class="workspace">
    
      @if(sidebarVisible() && viewMode === ViewMod.Home)
      {
      <aside class="sidebar" [class.open]="sidebarVisible()">
        <app-sidebar></app-sidebar>
      </aside>
    
      <div class="sidebar-backdrop" [class.open]="sidebarVisible()" (click)="changeSidebarVisible()">
      </div>
      }

      <main class="content" [class.reader-active]="viewMode === ViewMod.Single">

        @if(viewMode === ViewMod.Home)
        {
          <app-manga-home
            [activeManga]="selectedMangaId"
            (mangaSelected)="onMangaSelected($event)">
          </app-manga-home>
        }

        @if(viewMode === ViewMod.Chapters)
        {
          <manga-page [activeManga]="selectedMangaId">
          </manga-page>
        }

        @if(viewMode === ViewMod.Single)
        {
          <app-manga-reader [activeManga]="selectedMangaId">
          </app-manga-reader>
        }

      </main>

    </div>

  </div>

  <upload-file-window
    [isVisible]="showUploadWindow()"
    [tabId]="selectedMangaId"
    [viewMode]="viewMode"
    (closeWindow)="onUploadWindowClose()">
  </upload-file-window>

  <settings-window
    [isVisible]="showSettingsWindow()"
    (closeWindow)="onSettingsWindowClose()">
  </settings-window>

</div>